/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AcknowledgeRiskPolicyChallengeRequestBody = {
  /**
   * Acknowledgement token generated when a warn policy challenged the action.
   */
  ackToken: string;
};

/** @internal */
export type AcknowledgeRiskPolicyChallengeRequestBody$Outbound = {
  ack_token: string;
};

/** @internal */
export const AcknowledgeRiskPolicyChallengeRequestBody$outboundSchema:
  z.ZodMiniType<
    AcknowledgeRiskPolicyChallengeRequestBody$Outbound,
    AcknowledgeRiskPolicyChallengeRequestBody
  > = z.pipe(
    z.object({
      ackToken: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        ackToken: "ack_token",
      });
    }),
  );

export function acknowledgeRiskPolicyChallengeRequestBodyToJSON(
  acknowledgeRiskPolicyChallengeRequestBody:
    AcknowledgeRiskPolicyChallengeRequestBody,
): string {
  return JSON.stringify(
    AcknowledgeRiskPolicyChallengeRequestBody$outboundSchema.parse(
      acknowledgeRiskPolicyChallengeRequestBody,
    ),
  );
}
